const api = {
    getUsers: () => {
        return fetch('https://jsonplaceholder.typicode.com/users');
    }
}

export default api;